module.exports = __webpack_public_path__ + "static/media/MenuKidsGrilledCheese.c0fad2e4.jpg";